import React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import './List.less';
import SortDirection from '../../common/model/base/SortDirection';
import Pager from '../../common/model/base/Pager';
import StringUtil from '../../common/util/StringUtil';
import FileUtil from '../../common/util/FileUtil';
import DateUtil from '../../common/util/DateUtil';
import FilterPanel from '../widget/filter/FilterPanel';
import TableEmpty from '../widget/TableEmpty';
import User, { UserLimitType, UserLimitTypeList } from '../../common/model/user/User';
import HwzComponent from '../../common/component/HwzComponent';
import HwzTitle from '../widget/HwzTitle';
import SafeUtil from '../../common/util/SafeUtil';
import { ColumnProps } from 'antd/lib/table';
import { Button, Modal, Table, Tag, Tooltip, Upload, message, Input, Select, TreeSelect } from 'antd';
import {
  CheckCircleOutlined,
  PlusOutlined,
  StopOutlined,
  UserSwitchOutlined,
  DownloadOutlined,
  UploadOutlined,
  FileTextOutlined,
  SearchOutlined,
  ReloadOutlined,
} from '@ant-design/icons';
import { UserRoleMap, UserRole, UserRoleList } from '../../common/model/user/UserRole';
import { UserStatus, UserStatusMap } from '../../common/model/user/UserStatus';
import {
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleFilled,
} from '@ant-design/icons/lib';
import MessageBoxUtil from '../../common/util/MessageBoxUtil';
import Color from '../../common/model/base/option/Color';
import TransfigurationModal from './widget/TransfigurationModal';
import Lang from '../../common/model/global/Lang';
import Moon from '../../common/model/global/Moon';

interface IProps extends RouteComponentProps {}

interface IState {
  searchParams: {
    username?: string;
    status?: UserStatus;
    deptId?: string;
  };
  deptTreeData: any[];
  deptLoading: boolean;
  hasSearchCondition: boolean;
}

interface UserImportData {
  username: string;
  password: string;
  role: UserRole;
  sizeLimit: number;
  totalSizeLimit: number;
  userLimitType: UserLimitType;
  deptId?: string; // 部门ID
  deptName?: string; // 部门名称
}

export default class List extends HwzComponent<IProps, IState> {
  //获取分页的一个帮助器
  pager: Pager<User> = new Pager<User>(this, User, 10);

  constructor(props: IProps) {
    super(props);
    this.exportToCSV = this.exportToCSV.bind(this);
    this.handleImportCSV = this.handleImportCSV.bind(this);
    this.downloadTemplate = this.downloadTemplate.bind(this);
    
    this.state = {
      searchParams: {},
      deptTreeData: [],
      deptLoading: false,
      hasSearchCondition: false
    };
  }

  componentDidMount() {
    let that = this;

    that.pager.enableHistory();

    // 获取部门树数据
    that.fetchDeptTreeData();
    
    that.refresh();
  }

  // 搜索方法
  handleSearch = () => {
    let that = this;
    const values = that.state.searchParams;
    
    // 检查是否有搜索条件
    const hasCondition = !!(values.username || values.status || values.deptId);
    
    // 重置分页
    that.pager.page = 0;
    
    // 重置所有过滤器
    if (that.pager.resetFilter) {
      that.pager.resetFilter();
    }
    
    // 设置查询条件
    if (values.username) {
      that.pager.setFilterValue('username', values.username);
    }
    
    if (values.status) {
      that.pager.setFilterValue('status', values.status);
    }
    
    if (values.deptId) {
      that.pager.setFilterValue('deptShortName', values.deptId);
    }
    
    that.setState({ hasSearchCondition: hasCondition }, () => {
      that.refresh();
    });
  };

  // 重置搜索
  handleReset = () => {
    let that = this;
    that.setState({
      searchParams: {},
      hasSearchCondition: false
    }, () => {
      if (that.pager.resetFilter) {
        that.pager.resetFilter();
      }
      that.refresh();
    });
  };

  // 获取部门树形数据
  fetchDeptTreeData = () => {
    this.setState({ deptLoading: true });
    
    console.log('用户列表开始获取部门数据...');
    
    // 使用与部门管理列表相同的请求参数
    const requestBody = {
      page: 0,
      pageSize: 1000,
      orderIndex: 'ASC'
    };
    
    fetch('/api/sys/dept/page', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify(requestBody)
    })
    .then(response => {
      console.log('用户列表部门接口响应状态:', response.status);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        throw new Error(`Expected JSON, got ${contentType}`);
      }
      
      return response.json();
    })
    .then(data => {
      console.log('用户列表部门接口返回数据:', data);
      
      // 使用与部门管理列表相同的转换方法
      const treeData = this.convertDataFromBackend(data);
      console.log('转换后的树形数据:', treeData);
      console.log('树形数据长度:', treeData.length);
      
      // 将树形数据转换为TreeSelect需要的格式
      const treeSelectData = this.convertToTreeSelectData(treeData);
      console.log('TreeSelect数据:', treeSelectData);
      
      this.setState({ 
        deptTreeData: treeSelectData,
        deptLoading: false 
      });
    })
    .catch(error => {
      console.error('获取部门数据失败:', error);
      this.setState({ deptLoading: false });
    });
  };

  // 使用与部门管理列表相同的转换方法
  convertDataFromBackend = (rawData: any): any[] => {
    console.log('=== convertDataFromBackend 开始 ===');
    console.log('输入 rawData:', rawData);
    
    if (!rawData) {
      console.log('rawData 为空，返回空数组');
      return [];
    }
    
    let records: any[] = [];
    
    // 情况1：数据本身就是数组
    if (Array.isArray(rawData)) {
      console.log('情况1: rawData 是数组，直接使用');
      records = rawData;
    } 
    // 情况2：标准响应格式 {code: "OK", data: {...}}
    else if (rawData.code === "OK" || rawData.code === "SUCCESS" || rawData.Code === "OK") {
      console.log('情况2: 检测到标准响应格式，code:', rawData.code || rawData.Code);
      
      // 尝试从 data 字段提取
      const dataField = rawData.data || rawData.Data;
      if (dataField) {
        console.log('data 字段存在:', dataField);
        
        // 2.1: data 字段是数组
        if (Array.isArray(dataField)) {
          console.log('情况2.1: data 字段是数组');
          records = dataField;
        }
        // 2.2: data 字段是对象，包含 records 字段
        else if (dataField && typeof dataField === 'object' && dataField.records && Array.isArray(dataField.records)) {
          console.log('情况2.2: 在 data.records 找到数组');
          records = dataField.records;
        }
      }
    }
    // 情况3：直接包含 records 字段的对象
    else if (rawData && typeof rawData === 'object' && rawData.records && Array.isArray(rawData.records)) {
      console.log('情况3: 直接找到 records 字段数组');
      records = rawData.records;
    }
    // 情况4：直接就是树形结构数组
    else if (Array.isArray(rawData)) {
      console.log('情况4: rawData 是树形结构数组');
      records = rawData;
    }
    
    console.log('获取到的记录数:', records.length);
    
    // 处理树形结构数据，将 Children 字段转换为 children（小写）
    const processTreeData = (nodes: any[]): any[] => {
      return nodes.map(node => {
        const processedNode = { ...node };
        
        // 将 Children 字段重命名为 children（Ant Design Table 要求小写）
        if (processedNode.Children && Array.isArray(processedNode.Children)) {
          processedNode.children = processTreeData(processedNode.Children);
          delete processedNode.Children;
        } else if (processedNode.children && Array.isArray(processedNode.children)) {
          // 如果已经是 children，确保子节点也被处理
          processedNode.children = processTreeData(processedNode.children);
        }
        
        // 确保每个节点都有 key 属性（使用 id）
        if (processedNode.id) {
          processedNode.key = processedNode.id.toString();
        }
        
        return processedNode;
      });
    };
    
    // 处理树形数据
    records = processTreeData(records);
    
    console.log('处理后的记录数:', records.length);
    console.log('=== convertDataFromBackend 结束 ===');
    
    return records;
  };

  // 将树形数据转换为TreeSelect需要的格式
  convertToTreeSelectData = (nodes: any[]): any[] => {
    if (!nodes || nodes.length === 0) return [];
    
    return nodes.map(node => {
      const treeNode: any = {
        title: node.shortName || node.name || `部门${node.id}`,
        value: node.id ? node.id.toString() : '',
        key: node.id ? node.id.toString() : '',
        rawData: node
      };
      
      if (node.children && Array.isArray(node.children) && node.children.length > 0) {
        treeNode.children = this.convertToTreeSelectData(node.children);
      } else {
        treeNode.children = [];
      }
      
      return treeNode;
    });
  };

  search() {
    let that = this;
    that.pager.page = 0;
    that.refresh();
  }

  refresh() {
    let that = this;
  
    // 如果没有任何的排序，默认使用时间倒序
    if (!that.pager.getCurrentSortFilter()) {
      that.pager.setFilterValue('orderCreateTime', SortDirection.DESC);
    }
    
    // 添加调试信息
    that.pager.httpList(() => {
      // 列表加载完成后，检查是否有部门数据
      console.log('用户列表数据:', that.pager.data);
      if (that.pager.data && that.pager.data.length > 0) {
        const firstUser = that.pager.data[0];
        
        // 安全地获取部门显示名称
        let deptDisplayName = '--';
        if (firstUser.getDeptDisplayName && typeof firstUser.getDeptDisplayName === 'function') {
          deptDisplayName = firstUser.getDeptDisplayName();
        } else {
          if (firstUser.deptShortName && firstUser.deptShortName.trim() !== '') {
            deptDisplayName = firstUser.deptShortName;
          } else if (firstUser.deptName && firstUser.deptName.trim() !== '') {
            deptDisplayName = firstUser.deptName;
          } else if (firstUser.deptId && firstUser.deptId.trim() !== '') {
            deptDisplayName = `ID: ${firstUser.deptId}`;
          }
        }
        
        console.log('第一个用户的部门信息:', {
          deptId: firstUser.deptId,
          deptName: firstUser.deptName,
          deptShortName: firstUser.deptShortName,
          deptDisplayName: deptDisplayName,
          hasGetDeptDisplayNameMethod: typeof firstUser.getDeptDisplayName === 'function'
        });
      }
    });
  }

  toggleStatus(user: User) {
    let that = this;
    user.httpToggleStatus(function () {
      MessageBoxUtil.success(Lang.t('operationSuccess'));
      that.updateUI();
    });
  }

  delete(user: User) {
    let that = this;
    Modal.confirm({
      title: Lang.t('user.deleteHint', user.username),
      icon: <ExclamationCircleFilled twoToneColor={Color.WARNING} />,
      onOk: () => {
        user.httpDel(function () {
          MessageBoxUtil.success(Lang.t('operationSuccess'));
          that.refresh();
        });
      },
    });
  }

  transfiguration(user: User) {
    let that = this;
    TransfigurationModal.open(user);
  }

  // 修改后的导出CSV方法 - 直接从当前列表数据导出
  exportToCSV() {
    let that = this;
    
    try {
      // 获取当前显示的列表数据
      const currentData = that.pager.data || [];
      
      if (!currentData || currentData.length === 0) {
        MessageBoxUtil.warning(Lang.t('user.noDataToExport'));
        return;
      }

      // 生成CSV内容
      const csvContent = this.generateCSV(currentData);
      
      // 创建并下载CSV文件
      this.downloadCSV(csvContent, `users_export_${DateUtil.format(new Date(), 'YYYY-MM-DD_HH-mm-ss')}.csv`);
      
      MessageBoxUtil.success(Lang.t('user.exportSuccess'));
    } catch (error) {
      console.error('导出CSV失败:', error);
      MessageBoxUtil.error(Lang.t('user.exportFailed'));
    }
  }

  // 生成CSV内容的方法 - 前几列与模板统一（可直接用于导入创建用户），后续为信息列
  generateCSV(data: User[]): string {
    // 统一的导入列（与模板列一致）
    const columns = [
      { key: 'username', title: Lang.t('user.username'), value: (user: User) => user.username },
      { key: 'password', title: Lang.t('user.password'), value: () => '' },
      { key: 'role', title: Lang.t('user.role'), value: (user: User) => user.role },
      { key: 'sizeLimit', title: Lang.t('user.singleFileSizeLimit'), value: (user: User) => user.space ? user.space.getHumanizeSizeLimit() : '' },
      { key: 'totalSizeLimit', title: Lang.t('user.totalFileSizeLimit'), value: (user: User) => user.space ? user.space.getHumanizeTotalSizeLimit() : '' },
      { key: 'userLimitType', title: Lang.t('user.userLimitType'), value: (user: User) => user.userLimitType },
      { key: 'dept', title: Lang.t('user.department'), value: (user: User) => user.deptShortName || user.deptName || user.deptId || '' },
    ];

    // 追加的信息列（导入时会被忽略，仅用于查看）
    const infoColumns = [
      { key: 'totalFileSize', title: Lang.t('user.totalFileSize'), value: (user: User) => user.space ? user.space.getHumanizeTotalSize() : '' },
      { key: 'status', title: Lang.t('user.status'), value: (user: User) => UserStatusMap[user.status]?.name || user.status },
      { key: 'expirationDate', title: Lang.t('user.expirationDate'), value: (user: User) => !user.expirationDate ? Lang.t('user.permanent') : DateUtil.simpleDateTime(user.expirationDate) },
      { key: 'lastLogin', title: Lang.t('user.lastLogin'), value: (user: User) => `${user.lastIp || ''}\n${user.lastTime ? DateUtil.simpleDateTime(user.lastTime) : ''}` },
      { key: 'createTime', title: Lang.t('createTime'), value: (user: User) => user.createTime ? DateUtil.simpleDateTime(user.createTime) : '' },
    ];

    const allColumns = columns.concat(infoColumns);

    // CSV头部
    const headers = allColumns.map(col => this.escapeCSVField(col.title)).join(',');

    // CSV数据行
    const rows = data.map(user => {
      return allColumns.map(col => this.escapeCSVField(col.value(user))).join(',');
    });

    return [headers, ...rows].join('\n');
  }

  // CSV字段转义处理
  escapeCSVField(field: any): string {
    if (field === null || field === undefined) {
      return '';
    }
    
    const stringValue = String(field);
    
    // 如果包含逗号、换行符或引号，需要用引号包围并转义内部引号
    if (stringValue.includes(',') || stringValue.includes('\n') || stringValue.includes('"') || stringValue.includes('\r')) {
      return `"${stringValue.replace(/"/g, '""')}"`;
    }
    
    return stringValue;
  }

  // 下载CSV文件
  downloadCSV(csvContent: string, filename: string) {
    // 添加BOM头解决中文乱码问题
    const BOM = '\uFEFF';
    const contentWithBOM = BOM + csvContent;
    
    const blob = new Blob([contentWithBOM], { 
      type: 'text/csv; charset=utf-8'
    });
    
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    
    link.href = url;
    link.download = filename;
    link.style.display = 'none';
    
    document.body.appendChild(link);
    link.click();
    
    // 清理
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 100);
  }

  // 下载批量创建用户模板（与导出的CSV格式统一，均可用于导入创建用户）
  downloadTemplate() {
    try {
      // 统一的表头（与导出CSV前几列一致）
      const columns = this.getUnifiedColumns();
      const headers = columns.map(col => this.escapeCSVField(col.title)).join(',');

      // 添加示例行，帮助用户理解格式
      const exampleRows = [
        ['user1', '', 'USER', '10485760', '1073741824', 'READ_WRITE', '1'],
        ['user2', 'HWZ@1234', '普通用户', '10MB', '1GB', '读写权限', '2'],
        ['user3', '', '', '5242880', '536870912', '', ''],
      ];

      // 生成CSV内容
      let csvContent = headers + '\n';

      // 添加示例行
      exampleRows.forEach(row => {
        csvContent += row.map(field => this.escapeCSVField(field)).join(',') + '\n';
      });

      // 创建并下载模板文件
      this.downloadCSV(csvContent, `user_batch_template_${DateUtil.format(new Date(), 'YYYY-MM-DD')}.csv`);

      MessageBoxUtil.success(Lang.t('user.templateDownloadSuccess'));
    } catch (error) {
      console.error('下载模板失败:', error);
      MessageBoxUtil.error(Lang.t('user.templateDownloadFailed'));
    }
  }

  // 新增: 处理CSV文件导入和批量创建用户
  handleImportCSV = (file: File) => {
    return new Promise<void>((resolve, reject) => {
      const reader = new FileReader();
      
      reader.onload = (e) => {
        try {
          const csvContent = e.target?.result as string;
          // 使用正确的CSV解析器，兼容带引号（含换行/逗号）的字段，过滤空行
          const rows = this.parseCSVRows(csvContent).filter(
            row => !(row.length === 1 && row[0].trim() === '')
          );

          if (rows.length === 0) {
            MessageBoxUtil.error(Lang.t('user.importEmptyFile'));
            reject(new Error('Empty file'));
            return;
          }

          // 解析表头建立列映射；若无表头则按统一顺序解析
          const headerCells = rows[0].map(col => col.trim());
          let colIndex: { [key: string]: number } | null = this.parseCsvColumns(headerCells);
          let startLine = 0;
          if (colIndex) {
            startLine = 1;
          } else {
            // 无表头的文件：按统一列顺序 username,password,role,sizeLimit,totalSizeLimit,userLimitType,dept
            colIndex = {};
            this.getUnifiedColumns().forEach((col, idx) => {
              (colIndex as { [key: string]: number })[col.key] = idx;
            });
          }

          // 解析CSV，获取用户信息（模板与导出的CSV均可解析）
          const userDataList: UserImportData[] = [];
          rows.slice(startLine).forEach((row) => {
            const cells = row.map(col => col.trim());
            const get = (key: string): string => {
              const idx = colIndex ? colIndex[key] : undefined;
              return idx !== undefined && cells[idx] !== undefined ? cells[idx] : '';
            };
            
            const username = get('username').trim();
            if (!username) {
              return;
            }
            
            const sizeLimit = this.parseSizeLimit(get('sizeLimit'));
            const totalSizeLimit = this.parseSizeLimit(get('totalSizeLimit'));
            const role = this.resolveRoleValue(get('role'));
            const userLimitType = this.resolveUserLimitType(get('userLimitType'));
            const password = get('password').trim();
            
            // 部门：支持ID或名称
            const deptVal = get('dept').trim();
            const deptNode = deptVal ? this.findDeptNode(deptVal) : null;
            
            userDataList.push({
              username,
              password,
              role,
              sizeLimit,
              totalSizeLimit,
              userLimitType,
              deptId: deptNode ? deptNode.value : undefined,
              deptName: deptNode ? (deptNode.rawData && deptNode.rawData.name) || deptNode.title : undefined,
            });
          });
          
          if (userDataList.length === 0) {
            MessageBoxUtil.error(Lang.t('user.noValidUserData'));
            reject(new Error('No valid user data'));
            return;
          }
          
          Modal.confirm({
            title: Lang.t('user.batchCreateConfirm'),
            content: (
              <div>
                <p>{Lang.t('user.willCreateUsers', userDataList.length)}</p>
                <ul style={{ maxHeight: '200px', overflow: 'auto' }}>
                  {userDataList.map((userData, index) => (
                    <li key={index}>
                      {userData.username}
                      {`(角色: ${this.getRoleDisplayName(userData.role)}, `}
                      {`单文件: ${userData.sizeLimit === -1 ? Lang.t('preference.noLimit') : this.formatBytes(userData.sizeLimit)}, `}
                      {`总空间: ${userData.totalSizeLimit === -1 ? Lang.t('preference.noLimit') : this.formatBytes(userData.totalSizeLimit)}, `}
                      {`限制类型: ${this.getLimitTypeDisplayName(userData.userLimitType)}, `}
                      {`部门: ${userData.deptName || userData.deptId || '未设置'}, `}
                      {`密码: ${userData.password ? '已指定' : '默认'})`}
                    </li>
                  ))}
                </ul>
                <p>
                  {Lang.t('user.defaultPassword')} HWZ@1234{`（${Lang.t('user.password')}留空时使用）`}
                </p>
              </div>
            ),
            okText: Lang.t('confirm'),
            cancelText: Lang.t('cancel'),
            onOk: () => {
              this.batchCreateUsers(userDataList);
              resolve();
            },
            onCancel: () => {
              reject(new Error('User cancelled'));
            }
          });
        } catch (error) {
          console.error('解析CSV文件失败:', error);
          MessageBoxUtil.error(Lang.t('user.importParseFailed'));
          reject(error);
        }
      };
      
      reader.onerror = () => {
        MessageBoxUtil.error(Lang.t('user.importReadFailed'));
        reject(new Error('File read error'));
      };
      
      reader.readAsText(file);
    });
  };

  // 解析大小限制（支持数字和带单位的大小）
  parseSizeLimit(sizeStr: string): number {
    if (!sizeStr) return 100 * 1024 * 1024; // 默认100MB
    
    // 去除空格并转为大写
    const cleanStr = sizeStr.trim().toUpperCase();
    
    // 无限制（导出时可能为"无限制"/"UNLIMITED"/-1）
    if (cleanStr === '无限制' || cleanStr === '不限' || cleanStr === '无限' ||
        cleanStr === 'UNLIMITED' || cleanStr === '-1') {
      return -1;
    }
    
    // 如果是纯数字，直接返回
    if (!isNaN(Number(cleanStr))) {
      return Number(cleanStr);
    }
    
    // 解析带单位的大小 - 支持 G, GB, M, MB 等格式
    const units: { [key: string]: number } = {
      'B': 1,
      'K': 1024,
      'KB': 1024,
      'M': 1024 * 1024,
      'MB': 1024 * 1024,
      'G': 1024 * 1024 * 1024,
      'GB': 1024 * 1024 * 1024,
      'T': 1024 * 1024 * 1024 * 1024,
      'TB': 1024 * 1024 * 1024 * 1024
    };
    
    // 匹配数字和单位
    const match = cleanStr.match(/^(\d+(?:\.\d+)?)\s*([KMGTP]?B?)$/);
    if (match) {
      const value = parseFloat(match[1]);
      const unit = match[2] || 'B';
      if (units[unit]) {
        return value * units[unit];
      }
    }
    
    console.warn(`无法解析大小格式: ${sizeStr}，使用默认值100MB`);
    return 100 * 1024 * 1024; // 默认100MB
  }

  // 统一的CSV列定义（模板/导出/导入共用，顺序一致）
  getUnifiedColumns(): Array<{ key: string; title: string }> {
    return [
      { key: 'username', title: Lang.t('user.username') },
      { key: 'password', title: Lang.t('user.password') },
      { key: 'role', title: Lang.t('user.role') },
      { key: 'sizeLimit', title: Lang.t('user.singleFileSizeLimit') },
      { key: 'totalSizeLimit', title: Lang.t('user.totalFileSizeLimit') },
      { key: 'userLimitType', title: Lang.t('user.userLimitType') },
      { key: 'dept', title: Lang.t('user.department') },
    ];
  }

  // 表头标准化（去空格/下划线/连字符，转小写）
  normalizeHeader = (s: string): string => (s || '').trim().toLowerCase().replace(/[\s_\-]/g, '');

  // 表头别名 -> 统一列key的映射
  getColumnAliasMap(): { [normalized: string]: string } {
    const aliases: { [key: string]: string[] } = {
      username: [Lang.t('user.username'), 'username', 'user_name', '用户', '用户名称'],
      password: [Lang.t('user.password'), 'password', '用户密码'],
      role: [Lang.t('user.role'), 'role', '用户角色'],
      sizeLimit: [Lang.t('user.singleFileSizeLimit'), 'singleFileSizeLimit', 'singleFileLimit', '单文件限制', '单文件大小限制', '单文件大小'],
      totalSizeLimit: [Lang.t('user.totalFileSizeLimit'), 'totalFileSizeLimit', 'totalFileLimit', '总空间限制', '总文件大小限制', '总空间'],
      userLimitType: [Lang.t('user.userLimitType'), 'userLimitType', 'limitType', '限制类型', '权限类型', '用户限制类型'],
      dept: [Lang.t('user.department'), 'department', 'dept', 'deptId', '部门ID', '部门id', '部门名称', '所属部门', 'user.departmentId'],
    };
    const map: { [normalized: string]: string } = {};
    Object.keys(aliases).forEach((key) => {
      aliases[key].forEach((alias) => {
        map[this.normalizeHeader(alias)] = key;
      });
    });
    return map;
  }

  // 识别表头并建立 列key -> 索引 的映射；不是表头返回null
  parseCsvColumns(headerCells: string[]): { [key: string]: number } | null {
    const aliasMap = this.getColumnAliasMap();
    const indexMap: { [key: string]: number } = {};
    let recognized = 0;
    headerCells.forEach((cell, idx) => {
      const key = aliasMap[this.normalizeHeader(cell)];
      if (key && indexMap[key] === undefined) {
        indexMap[key] = idx;
        recognized++;
      }
    });
    if (recognized === 0) {
      return null;
    }
    return indexMap;
  }

  // 正确的CSV解析：支持带引号的字段（含逗号、换行、双引号转义），兼容导出CSV中的信息列
  parseCSVRows(csvContent: string): string[][] {
    const rows: string[][] = [];
    let row: string[] = [];
    let field = '';
    let inQuotes = false;
    const content = csvContent || '';
    const len = content.length;
    let i = 0;

    while (i < len) {
      const ch = content[i];
      if (inQuotes) {
        if (ch === '"') {
          if (i + 1 < len && content[i + 1] === '"') {
            field += '"';
            i += 2;
            continue;
          }
          inQuotes = false;
          i++;
          continue;
        }
        field += ch;
        i++;
        continue;
      }
      if (ch === '"') {
        inQuotes = true;
        i++;
        continue;
      }
      if (ch === ',') {
        row.push(field);
        field = '';
        i++;
        continue;
      }
      if (ch === '\r') {
        if (i + 1 < len && content[i + 1] === '\n') {
          i++;
        }
        row.push(field);
        field = '';
        rows.push(row);
        row = [];
        i++;
        continue;
      }
      if (ch === '\n') {
        row.push(field);
        field = '';
        rows.push(row);
        row = [];
        i++;
        continue;
      }
      field += ch;
      i++;
    }
    if (field !== '' || row.length > 0) {
      row.push(field);
      rows.push(row);
    }
    return rows;
  }

  // 解析角色值（支持英文枚举和中文名称），空值或无法识别回退普通用户；创建不支持游客，回退普通用户
  resolveRoleValue = (val: string): UserRole => {
    const v = (val || '').trim();
    if (!v) return UserRole.USER;
    const upper = v.toUpperCase();
    if (upper === UserRole.USER || upper === '普通用户') return UserRole.USER;
    if (upper === UserRole.ADMINISTRATOR || upper === '管理员') return UserRole.ADMINISTRATOR;
    if (upper === UserRole.AUDIT || upper === '审计') return UserRole.AUDIT;
    if (upper === UserRole.GUEST || upper === '游客') return UserRole.USER;
    const found = UserRoleList.find(o => o.value.toUpperCase() === upper || o.name === v);
    if (found) {
      const role = found.value as UserRole;
      return role === UserRole.GUEST ? UserRole.USER : role;
    }
    return UserRole.USER;
  };

  // 解析用户限制类型（支持英文枚举和中文名称），空值回退读写权限
  resolveUserLimitType = (val: string): UserLimitType => {
    const v = (val || '').trim();
    if (!v) return UserLimitType.READ_WRITE;
    const upper = v.toUpperCase();
    if (upper === 'READ_WRITE' || upper === '读写权限') return UserLimitType.READ_WRITE;
    if (upper === 'UPLOAD_PREVIEW' || upper === '上传预览权限') return UserLimitType.UPLOAD_PREVIEW;
    if (upper === 'READ_ONLY' || upper === '只读权限') return UserLimitType.READ_ONLY;
    const found = UserLimitTypeList.find(o => o.name === v || o.value.toUpperCase() === upper);
    return found ? (found.value as UserLimitType) : UserLimitType.READ_WRITE;
  };

  // 根据部门ID或名称查找部门节点
  findDeptNode = (val: string): any => {
    const target = (val || '').trim();
    if (!target) return null;
    const findInTree = (nodes: any[]): any => {
      for (const node of nodes) {
        if (node.value === target || node.title === target ||
            (node.rawData && (node.rawData.name === target || node.rawData.shortName === target))) {
          return node;
        }
        if (node.children && node.children.length > 0) {
          const found = findInTree(node.children);
          if (found) {
            return found;
          }
        }
      }
      return null;
    };
    return findInTree(this.state.deptTreeData);
  };

  // 角色显示名称
  getRoleDisplayName = (role: UserRole): string => {
    const opt = UserRoleMap[role];
    return opt ? opt.name : role;
  };

  // 限制类型显示名称
  getLimitTypeDisplayName = (limitType: UserLimitType): string => {
    const opt = UserLimitTypeList.find(item => item.value === limitType);
    return opt ? opt.name : limitType;
  };

  // 格式化字节大小
  formatBytes(bytes: number): string {
    if (bytes === 0) return '0 B';
    
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  // 新增: 批量创建用户 - 使用正确的httpSave参数
  batchCreateUsers = async (userDataList: UserImportData[]) => {
    let that = this;
    const defaultPassword = 'HWZ@1234'; // 默认密码
    
    try {
      MessageBoxUtil.info(Lang.t('user.batchCreateStart', userDataList.length));
      
      let successCount = 0;
      let errorCount = 0;
      
      // 逐个创建用户
      for (const userData of userDataList) {
        try {
          // 创建新用户对象
          const newUser = new User();
          newUser.username = userData.username;
          newUser.password = userData.password || defaultPassword;
          newUser.status = UserStatus.OK;
          newUser.role = userData.role || UserRole.USER;
          newUser.userLimitType = userData.userLimitType || UserLimitType.READ_WRITE;
          
          // 设置部门ID
          if (userData.deptId) {
            newUser.deptId = userData.deptId;
            
            // 如果可能，也设置部门名称
            if (userData.deptName) {
              newUser.deptName = userData.deptName;
            } else {
              const dept = this.findDeptNode(userData.deptId);
              if (dept) {
                newUser.deptName = dept.rawData?.name;
                newUser.deptShortName = dept.rawData?.shortName;
              }
            }
          }
          
          const spaceConfig = {
            sizeLimit: userData.sizeLimit,
            totalSizeLimit: userData.totalSizeLimit
          };
          
          // 设备信息配置（使用默认值）
          const deviceInfo = {
            allowedDevices: [], // 默认不限制设备类型
            allowedIpRange: '', // 默认不限制IP范围
            bindDeviceFeature: false // 默认关闭绑定终端特征
          };
          
          // 调用创建用户的API，传递正确的参数
          await new Promise<void>((resolve, reject) => {
            newUser.httpSave(
              spaceConfig, // 第一个参数：空间配置
              deviceInfo,  // 第二个参数：设备信息配置
              () => {      // 第三个参数：成功回调
                successCount++;
                resolve();
              },
              (error: any) => { // 第四个参数：失败回调
                errorCount++;
                console.error(`创建用户 ${userData.username} 失败:`, error);
                resolve(); // 继续处理下一个用户
              }
            );
          });
          
          // 添加延迟避免请求过于频繁
          await new Promise(resolve => setTimeout(resolve, 100));
          
        } catch (error) {
          errorCount++;
          console.error(`创建用户 ${userData.username} 异常:`, error);
        }
      }
      
      // 显示结果
      if (errorCount === 0) {
        MessageBoxUtil.success(Lang.t('user.batchCreateSuccess', successCount));
      } else {
        MessageBoxUtil.warning(
          Lang.t('user.batchCreatePartial', successCount, errorCount)
        );
      }
      
      // 刷新用户列表
      that.refresh();
      
    } catch (error) {
      console.error('批量创建用户失败:', error);
      MessageBoxUtil.error(Lang.t('user.batchCreateFailed'));
    }
  };

  // 渲染搜索表单
  renderSearchForm = () => {
    const { searchParams } = this.state;
    
    return (
      <div style={{ marginBottom: 16, padding: 16, background: '#fff', borderRadius: 4 }}>
        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
          <div style={{ flex: 1, minWidth: 200 }}>
            <div style={{ marginBottom: 8, fontWeight: 'bold' }}>{Lang.t('user.username')}</div>
            <Input
              placeholder={Lang.t('user.usernamesearch')}
              value={searchParams.username}
              onChange={(e) => this.setState(prev => ({
                searchParams: { ...prev.searchParams, username: e.target.value }
              }))}
              onPressEnter={this.handleSearch}
              allowClear
            />
          </div>
          
          <div style={{ flex: 1, minWidth: 200 }}>
            <div style={{ marginBottom: 8, fontWeight: 'bold' }}>{Lang.t('user.status')}</div>
            <Select
              placeholder={Lang.t('department.selectStatus')}
              style={{ width: '100%' }}
              value={searchParams.status}
              onChange={(value) => this.setState(prev => ({
                searchParams: { ...prev.searchParams, status: value }
              }))}
              allowClear
            >
              <Select.Option value={UserStatus.OK}>{UserStatusMap[UserStatus.OK].name}</Select.Option>
              <Select.Option value={UserStatus.DISABLED}>{UserStatusMap[UserStatus.DISABLED].name}</Select.Option>
            </Select>
          </div>
          
          <div style={{ flex: 1, minWidth: 200 }}>
            <div style={{ marginBottom: 8, fontWeight: 'bold' }}>{Lang.t('user.department')}</div>
            <TreeSelect
              placeholder={Lang.t('user.selectDepartment')}
              style={{ width: '100%' }}
              value={searchParams.deptId}
              onChange={(value) => this.setState(prev => ({
                searchParams: { ...prev.searchParams, deptId: value }
              }))}
              allowClear
              treeData={this.state.deptTreeData}
              treeDefaultExpandAll
              showSearch
              treeNodeFilterProp="title"
              loading={this.state.deptLoading}
              fieldNames={{
                label: 'title',
                value: 'value',
                children: 'children'
              }}
              notFoundContent={
                this.state.deptLoading ? 
                  '加载中...' : 
                  this.state.deptTreeData.length === 0 ?
                    '暂无部门数据' :
                    '未找到匹配的部门'
              }
            />
          </div>
          
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8 }}>
            <Button 
              type="primary" 
              icon={<SearchOutlined />}
              onClick={this.handleSearch}
            >
              {Lang.t('search')}
            </Button>
            <Button 
              icon={<ReloadOutlined />}
              onClick={this.handleReset}
            >
              {Lang.t('reset')}
            </Button>
          </div>
        </div>
      </div>
    );
  };

  render() {
    let that = this;
  
    // router中传入的路由相关对象
    let match = this.props.match;
  
    // pager对象
    let pager = this.pager;
  
    let user: User = Moon.getSingleton().user;
  
    // 添加调试信息
    console.log('用户列表组件状态:', {
      deptTreeData: this.state.deptTreeData,
      deptTreeDataLength: this.state.deptTreeData.length,
      deptLoading: this.state.deptLoading,
      userListData: pager.data
    });
  
    const columns: ColumnProps<User>[] = [
      {
        title: Lang.t('user.avatar'),
        dataIndex: 'avatarUrl',
        render: (text: any, record: User, index: number): React.ReactNode => (
          <Link to={StringUtil.prePath(match.path) + '/detail/' + record.uuid}>
            <img
              alt="avatar"
              className="avatar-small cursor"
              src={record.getAvatarUrl()}
            />
          </Link>
        ),
      },
      {
        title: Lang.t('user.username'),
        dataIndex: 'username',
        render: (text: any, record: User, index: number): React.ReactNode => {
          return (
            <div>
              <div>
                <Link
                  to={StringUtil.prePath(match.path) + '/detail/' + record.uuid}
                >
                  {record.username}
                </Link>
              </div>
              {user.uuid === record.uuid && (
                <div className="text-danger">{Lang.t('user.currentuser')}</div>
              )}
            </div>
          );
        },
      },
      // 部门列
      {
        title: Lang.t('user.department'),
        dataIndex: 'deptShortName',
        render: (text: any, record: User, index: number): React.ReactNode => {
          // 安全的获取部门显示名称
          let deptDisplayName = '--';
          
          // 方法1：如果有getDeptDisplayName方法
          if (record.getDeptDisplayName && typeof record.getDeptDisplayName === 'function') {
            deptDisplayName = record.getDeptDisplayName();
          }
          // 方法2：如果没有方法，直接使用字段
          else {
            if (record.deptShortName && record.deptShortName.trim() !== '') {
              deptDisplayName = record.deptShortName;
            } else if (record.deptName && record.deptName.trim() !== '') {
              deptDisplayName = record.deptName;
            } else if (record.deptId && record.deptId.trim() !== '') {
              deptDisplayName = `ID: ${record.deptId}`;
            }
          }
          
          // 添加调试信息
          console.log(`用户 ${record.username} 的部门信息:`, {
            deptId: record.deptId,
            deptName: record.deptName,
            deptShortName: record.deptShortName,
            deptDisplayName: deptDisplayName,
            hasGetDeptDisplayName: typeof record.getDeptDisplayName === 'function'
          });
          
          return (
            <span>
              {deptDisplayName === '--' ? 
                <span className="text-muted">未设置</span> : 
                <span style={{ color: '#1890ff' }}>{deptDisplayName}</span>
              }
            </span>
          );
        },
      },
      {
        title: Lang.t('user.role'),
        dataIndex: 'role',
        render: (text: any, record: User, index: number): React.ReactNode => (
          <Tag color={UserRoleMap[record.role].color}>
            {UserRoleMap[record.role].name}
          </Tag>
        ),
      },
      {
        title: Lang.t('user.singleFileSizeLimit'),
        render: (text: any, record: User, index: number): React.ReactNode => (
          <span>{record.space?.getHumanizeSizeLimit()}</span>
        ),
      },
      {
        title: Lang.t('user.totalFileSize'),
        render: (text: any, record: User, index: number): React.ReactNode => (
          <span>{record.space?.getHumanizeTotalSize()}</span>
        ),
      },
      {
        title: Lang.t('user.totalFileSizeLimit'),
        render: (text: any, record: User, index: number): React.ReactNode => (
          <span>{record.space?.getHumanizeTotalSizeLimit()}</span>
        ),
      },
      {
        title: Lang.t('user.status'),
        dataIndex: 'status',
        render: (text: any, record: User, index: number): React.ReactNode => (
          <Tag color={UserStatusMap[record.status].color}>
            {UserStatusMap[record.status].name}
          </Tag>
        ),
      },
      // ==================== 新增：授权截止日期列 ====================
      {
        title: Lang.t('user.expirationDate', '授权截止日期'),
        dataIndex: 'expirationDate',
        render: (text: any, record: User, index: number): React.ReactNode => {
          if (!record.expirationDate) {
            return <span>{Lang.t('user.permanent', '永久')}</span>;
          }
          const dateStr = DateUtil.simpleDate(record.expirationDate);
          // 判断是否过期（假设 User 模型有 isExpired 方法）
          if (record.isExpired && record.isExpired()) {
            return (
              <Tooltip title={Lang.t('user.expiredTip', '账号已过期，请续期')}>
                <span style={{ color: 'red' }}>{dateStr}</span>
                <Tag color="red" style={{ marginLeft: 4 }}>{Lang.t('user.expired', '已过期')}</Tag>
              </Tooltip>
            );
          }
          return <span>{dateStr}</span>;
        },
      },
      // ============================================================
      {
        title: Lang.t('user.lastLogin'),
        dataIndex: 'lastTime',
        render: (text: any, record: User, index: number): React.ReactNode => (
          <div>
            <div>{record.lastIp}</div>
            <div>{DateUtil.simpleDateTime(record.lastTime)}</div>
          </div>
        ),
      },
      {
        title: Lang.t('createTime'),
        dataIndex: 'createTime',
        sorter: true,
        sortOrder: pager.getDefaultSortOrder('createTime'),
        sortDirections: [SortDirection.DESCEND, SortDirection.ASCEND],
        render: (text: any, record: User, index: number): React.ReactNode =>
          DateUtil.simpleDateTime(text),
      },
      {
        title: Lang.t('operation'),
        dataIndex: 'action',
        render: (text: any, record: User) => (
          <span>
            <Link
              title={Lang.t('edit')}
              to={StringUtil.prePath(match.path) + '/edit/' + record.uuid}
            >
              <Tooltip title={Lang.t('edit')}>
                <EditOutlined className="btn-action" />
              </Tooltip>
            </Link>
  
            {record.status === UserStatus.OK && record.uuid !== user.uuid && (
              <Tooltip title={Lang.t('user.disableUser')}>
                <StopOutlined
                  className="btn-action"
                  style={{ color: Color.DANGER }}
                  onClick={this.toggleStatus.bind(this, record)}
                />
              </Tooltip>
            )}
  
            {record.status === UserStatus.DISABLED &&
              record.uuid !== user.uuid && (
                <Tooltip title={Lang.t('user.activeUser')}>
                  <CheckCircleOutlined
                    className="btn-action"
                    style={{ color: Color.SUCCESS }}
                    onClick={this.toggleStatus.bind(this, record)}
                  />
                </Tooltip>
              )}
  
            {record.status === UserStatus.DISABLED &&
              record.uuid !== user.uuid && (
                <Tooltip title={Lang.t('user.deleteUser')}>
                  <DeleteOutlined
                    className="btn-action"
                    style={{ color: Color.DANGER }}
                    onClick={this.delete.bind(this, record)}
                  />
                </Tooltip>
              )}
  
            {record.uuid !== user.uuid && (
              <Tooltip title={Lang.t('user.transfiguration')}>
                <UserSwitchOutlined
                  className="btn-action"
                  style={{ color: Color.PRIMARY }}
                  onClick={this.transfiguration.bind(this, record)}
                />
              </Tooltip>
            )}
          </span>
        ),
      },
    ];
  
    // 上传组件的配置
    const uploadProps = {
      accept: '.csv',
      beforeUpload: (file: File) => {
        that.handleImportCSV(file);
        return false; // 阻止自动上传
      },
      showUploadList: false,
    };
  
    return (
      <div className="page-user-list">
        <HwzTitle name={Lang.t('layout.users')}>
          <div>
            <Link to={'/user/create'} style={{ marginRight: 10 }}>
              <Button type={'primary'} icon={<PlusOutlined />}>
                {Lang.t('user.createUser')}
              </Button>
            </Link>
       
            <Button 
              icon={<DownloadOutlined />} 
              onClick={this.exportToCSV}
              style={{ marginRight: 10 }}
            >
              {Lang.t('exportcsv')}
            </Button>
  
            {/* 新增: 下载模板按钮 */}
            <Button 
              icon={<FileTextOutlined />}
              onClick={this.downloadTemplate}
              style={{ marginRight: 10 }}
            >
              {Lang.t('user.downloadTemplate')}
            </Button>
  
            {/* 新增: 导入创建用户按钮 */}
            <Upload {...uploadProps}>
              <Button 
                icon={<UploadOutlined />}
              >
                {Lang.t('user.importCreateUsers')}
              </Button>
            </Upload>
          </div>
        </HwzTitle>
  
        {/* 自定义搜索表单 */}
        {this.renderSearchForm()}
  
        {/* 表格 */}
        <Table
          rowKey="uuid"
          loading={pager.loading}
          dataSource={pager.data}
          columns={columns}
          pagination={pager.getPagination()}
          onChange={pager.tableOnChange.bind(pager)}
          locale={{
            emptyText: (
              <TableEmpty pager={pager} onRefresh={this.refresh.bind(this)} />
            ),
          }}
        />
      </div>
    );
  }
}